<template>
    <div>
        <div class="qz-search-wrap">
            <van-search
                    v-model="keywords"
                    placeholder="请输入搜索关键词"
                    show-action

                    @search="onSearch"
            >
                <div slot="action" @click="onSearch(keywords)" style="padding:0 10px">搜索</div>
            </van-search>
        </div>
        <!--<input class="test" autofocus="autofocus" />-->
        <div v-if="!keywords && history_list.length>0" class="search-default">
            <h3 class="title">搜索历史 <em @click="emptyHistory" style="float: right ; margin-right: 20px">清除</em></h3>

            <div class="cf"></div>
            <ul class="result cf">
                <li v-for="(item,index) in history_list" class="item" :key="index" @click="onSearch(item) ">{{item}}</li>
            </ul>
            <div class="cf"></div>
        </div>
        <div class="" v-if="emptyShow">
            <van-empty style="margin: 10px auto" description="暂无结果" />
        </div>
        <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
        </div>

    </div>
</template>
<style scoped>
    .search-default{ background-color: #fff;}
    .search-default .title{ line-height: 38px; padding-left: 13px; font-size: 14px; color: #999; font-weight: normal;}
    .search-default .result{}
    .search-default .result .item{ box-sizing: border-box; width: 50%; line-height: 36px; float: left; padding-left: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 14px; color: #666;}
    .cf{
        clear: both;
    }
    .equalblock-warp {
        width: 100%;
        display: flex;
        font-size: 0;
    }

    .equalblock-item {
        flex: 1;
    }

    .equalblock-pic {
        width: 100%;
        min-height: 30px;
    }

    span.s {
        width: 1px;
        background: rebeccapurple;
    }

    .equalblock-item .equalblock-title {
        font-size: 14px;
        display: inline-block;
        width: 100%;
        text-align: center;
        padding: 5px 0;
    }
</style>

<script>
    import {Search,
            Cell, CellGroup,Field,Button,Empty
    } from 'vant';
    import NewsItem2 from "@/components/news/NewsItem2.vue";
    import NewsItem3 from "@/components/news/NewsItem3.vue";
    import NewsItem1 from "@/components/news/NewsItem1.vue";
    import NewsItem4 from "@/components/news/NewsItem4.vue";
//    import $ from  'jquery';
    export default {
        name: 'goodsSearch',
        components: {
            [Search.name]: Search,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Button.name]: Button,
            [Empty.name]: Empty,
            NewsItem2,
            NewsItem3,
            NewsItem1,
            NewsItem4
        },
        data: function () {
            return {
                keywords:'',
                hot_list:[
                ],
                list:[],
                emptyShow :false,
                history_list:[]
            }
        },
        watch:{
            keywords(value) {
                if(!value){
                    return false;
                }
//                this.load();
            }
        },
        filter: {},
        created(){
            document.title = "搜索页";
            let that = this;
            that.history_list = JSON.parse( localStorage.getItem('search_history')|| '[]');
//            alert($('body').height())
        },
        mounted(){
            setTimeout(() => {
//                console.log('开始聚焦');
//                alert('开始聚焦');
//            $('.van-search__content input').focus();
//            $('.van-search__content input').click();
//            $('.test').focus();
        },100);
//            $('.van-search__content input').click(function(){
//                alert('开始聚焦');
//                $('.van-search__content input').focus();
//            })
        },
        methods: {
            onSearch(val){
                console.log(val);
                val = (val+'').trim();
                this.keywords = val;
                let search_history = JSON.parse( localStorage.getItem('search_history')|| '[]');
                if(search_history.indexOf(val) == -1){
                    search_history.push(val);
                    localStorage.setItem('search_history',JSON.stringify(search_history));
                    this.history_list = search_history;
                }
                this.load();
            },
            emptyHistory(){
                this.history_list = [];
                localStorage.setItem('search_history','[]');
            },
            load(){
                let that = this;
                this.$api.get(
                        "/api/cms/cmslist", {
                    keywords:that.keywords
                }, r => {
                    that.list = r.data.list;
                    if(r.data.list.length==0){
                        that.emptyShow  = true;
                    }else{
                        that.emptyShow  = false;
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SearchAll.vue?bf662eb8